export const authConstants = {
    ROLE_USER: 'ROLE_USER',
    ROLE_ADMIN: 'ROLE_ADMIN',
    ROLE_SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
    ROLE_DEVELOPER: 'ROLE_DEVELOPER',
    ROLE_PAYMENTS: 'ROLE_PAYMENTS',
    ROLE_WORKDAY_USER: 'ROLE_WORKDAY_USER',
    ROLE_ACCOUNTING_USER: 'ROLE_ACCOUNTING_USER',
};
